module.exports = __webpack_public_path__ + "img/empresa-01.f1a18373.jpg";